import { SETTING_ACTIVE_TAB } from "../Actions/actionType";

const INITIAL_STATE = {
  activeTab: "personal-info",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SETTING_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };

    default:
      return state;
  }
};
